import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f9f9f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <Typography variant="h1" fontWeight="bold" color="primary" gutterBottom>
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            Uh oh! Page not found.
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            The page you're trying to reach doesn't exist or has been moved.
          </Typography>
        </motion.div>

        {/* Floating Illustration */}
        <motion.img
          src="/images/404.png"
          alt="404 illustration"
          style={{ width: "100%", maxWidth: 300, margin: "2rem auto" }}
          initial={{ y: 0 }}
          animate={{ y: [0, -10, 0] }}
          transition={{
            repeat: Infinity,
            duration: 2,
            ease: "easeInOut",
          }}
        />

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/")}
          >
            Go to Homepage
          </Button>
        </motion.div>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
